import reduce from 'lodash/reduce';

const Constants = [
    'DEFAULT',
    'SUCCESS',
    'INFO',
    'ERROR',
];

const NotificationConstants = reduce(Constants, (accumulator, value) => {
    accumulator[value] = value;
    return accumulator;
}, {});

export default NotificationConstants;
